import Status from "../../../../status"

interface Props {
  deleted: boolean
  active: boolean
}

const EngagementsStatus = ({ deleted, active }: Props) => (
  <div className="mr-2 flex items-center">
    {deleted ? (
      <Status.Inactive label="Deleted" />
    ) : (
      <>
        {active ? (
          <Status.Active label="Active" />
        ) : (
          <Status.Idle label="Disabled" />
        )}
      </>
    )}
  </div>
)

export default EngagementsStatus
